// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrganizationCranesStatus_wrapper__AvGmt"};